<script>
  export let sprite = {},
    width,
    offset,
    borderRadius,
    onclick,
    ondragstart,
    className;
  $: aspectRatio = sprite?.width / sprite?.height;
  $: _width = width || sprite?.width;
  $: _height = _width / aspectRatio;
  $: offsetX = offset[1] * _width;
  $: offsetY = offset[0] * _height;
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
  class="component {sprite.class} {className}"
  style:border-radius="{borderRadius ? _width / borderRadius : 0}px"
  style:background-size="{100 * sprite.columns}%"
  style:background-position="-{offsetX}px -{offsetY}px"
  style:width="{_width}px"
  style:height="{_height}px"
  on:click={onclick}
  on:dragstart={ondragstart}
  {...$$props}
></div>

<style>
  .component {
    flex-shrink: 0;
  }

  .ENEMIES {
    background-image: url("img/CardsEnemies.jpg");
  }

  .PLAYERBOARD {
    background-image: url("img/Playerboards.jpg");
  }

  .ACTIONS {
    background-image: url("img/Action-Icons.png");
  }
  .ITEMS_FRONT {
    background-image: url("img/CardsItemsFront.jpg");
  }

  .ITEMS_BACK {
    background-image: url("img/CardsItemsBack.jpg");
  }
  .TOKENS {
    background-image: url("img/Tokens.jpg");
  }
  .AVATAR {
    background-image: url("img/Fight-Screen_Enemys_Heros.png");
  }
  .POTION {
    background-image: url("img/CardsPotions.jpg");
  }
</style>
